export default {
  /**
   * Para não fazer um getter para cada coluna, você pode invocar o getter passando o nome do objeto
   * que você quer que ele pegue do state, ex: this.getColunasExcel('colunasGestaoContainers')
   */
  getColunasExcel(state) {
    return (value) => state[value];
  },
};
